
import React from 'react'
import "./styles.scss"

const HeroSection = () => {

    return (
        <>
            <div className="container sectionHead mt80">
                <div className="row sHeading">
                    <div className="col-xl-8 col-12 text-center">
                        <h1>Find Your Perfect Plan</h1>
                        <p>Discover the ideal plan to fuel your business growth. Our pricing options are carefully crafted to cater to startups.</p>
                    </div>
                </div>

                {/* <div className="row MYTab">
                        <div className="btns active">Monthly</div>
                        <div className="btns ">Yearly</div>
                    </div> */}

                <div className="row ">
                    <div className="col contactBan">
                        <div>
                            <h3>Are you a pre-revenue start-up?</h3>
                            <p>For pre-revenue start-up until 5 laks per month revenue or 60 lakhs per annum can contact us. We have special pricing for you.</p>
                        </div>
                        <div className="btn">
                            <label>Contact Us</label>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default HeroSection;